<template>
    <div id="app">
        <template v-if="isLoading">
            <div class="section">
      <div class="container has-text-centered is-max-desktop my-6">
        <div class="">
            <pre style="background-color: var(--bulma-body-background-color);">
<code>
╔══════════════════════════════════════════════╗
║                                              ║
║  ████████╗██╗███╗   ███╗██╗███████╗████████╗ ║
║  ╚══██╔══╝██║████╗ ████║██║██╔════╝╚══██╔══╝ ║
║     ██║   ██║██╔████╔██║██║███████╗   ██║    ║
║     ██║   ██║██║╚██╔╝██║██║╚════██║   ██║    ║
║     ██║   ██║██║ ╚═╝ ██║██║███████║   ██║    ║
║     ╚═╝   ╚═╝╚═╝     ╚═╝╚═╝╚══════╝   ╚═╝    ║
║                                              ║
╚══════════════════════════════════════════════╝

╔══[Loading]══╗
║ ▒▒▒▒▒▒▒▒░░░ ║
╚═════════════╝
</code>
            </pre>
        </div>
        <p style="margin-top: 30rem; color: whitesmoke;"><small>Wow, if you read this, you're really fast.</small></p>
      </div>
  </div>
        </template>
        <CalendarView v-else :key="'calendar'" />
        
        <!-- Toast notifications -->
        <ToastContainer />
    </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import { storeToRefs } from 'pinia';
import CalendarView from './views/CalendarView.vue';
import ToastContainer from './components/ToastContainer.vue';
import { useBlocksStore } from './stores/blocks';

const store = useBlocksStore();
const { userSession, isFrontendOnly } = storeToRefs(store);
const isLoading = ref(true);

onMounted(async () => {
    const urlParams = new URLSearchParams(window.location.search);
    const isNewSession = urlParams.get('new_session');
    const isNewRegistration = urlParams.get('new_registration');

    if (isNewSession || isNewRegistration) {
        store.deleteLocalSession();
        // Clean URL without page reload
        window.history.replaceState({}, '', window.location.pathname);
    }

    await store.checkSession();

    // Demo mode is temporarily disabled — Timist is in private preview.
    // Only authenticated (non-local) sessions may use the app; anyone else
    // (fresh visitors or returning demo users) is sent back to the homepage.
    if (!userSession.value || isFrontendOnly.value) {
        store.deleteLocalSession();
        window.location.replace('/');
        return;
    }

    isLoading.value = false;
});
</script>